import React, { useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { Popover } from '@mui/material';

import { AutoCompleteSelectUI, InputUI, FormErrorUI, FormLabelUI, CheckboxUI, ChromeColorPickerUI } from '../Interface';

const CustomDocStatusFields = ({ viewField, documentTypeOptions }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    if (!viewField) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'color-popover' : undefined;

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-4">
        <Field
          type="autocomplete"
          name="documentTypeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Bizonylattípus" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.documentTypeId} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.documentTypeId) }}
          selectedValue={values.documentTypeId}
          selectedLabelValue={documentTypeOptions?.find((item) => item.value === values.documentTypeId)?.label || ''}
          dataset={documentTypeOptions}
          onChange={(_e, newVal) => {
            setFieldValue('documentTypeId', newVal?.value ?? null).then(() => {
              validateField('documentTypeId');
            });
          }}
        />
      </div>
      <div className="col-span-4">
        <Field
          type="text"
          name="code"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Kód" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.code} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.code && values.code !== '' }}
        />
      </div>
      <div className="col-span-4">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          type="number"
          name="visOrder"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Sorrend" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.visOrder} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.visOrder && values.visOrder !== '' }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          name="defaultValue"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Alapértelmezett" />}
          disabled={viewField}
        />
      </div>

      <div className="md:col-span-2 col-span-4">
        <Field
          name="active"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </div>

      <div className="md:col-span-1 col-span-4 pt-4">
        <div
          className={`${!viewField ? 'cursor-pointer' : 'cursor-not-allowed'} rounded-full shadow-[rgba(0,_0,_0,_0.54)_0px_1px_8px] w-[20px] h-[20px] mt-1`}
          style={{ background: values.color }}
          onClick={handlePopoverOpen}
        />
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'left',
          }}
        >
          <ChromeColorPickerUI
            color={values.color}
            onChange={(color) => {
              setFieldValue('color', color.hex);
            }}
          />
        </Popover>
      </div>
    </div>
  );
};

export default CustomDocStatusFields;
